import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Xiazai = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb4ca__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#bb4ca__a)">
            <path
              fillRule="evenodd"
              d="m22.474 33.302-8.888-8.888a2 2 0 0 1 2.828-2.828l5.578 5.577V6a2 2 0 0 1 4 0v21.18l5.594-5.594a2 2 0 1 1 2.828 2.829l-9 9a2 2 0 0 1-2.828 0l-.112-.113ZM44 42V24a2 2 0 0 0-4 0v16H8V24.008a2 2 0 0 0-4 0V42a2 2 0 0 0 2 2h36a2 2 0 0 0 2-2Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
